import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/shared/ProtectedRoute';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { AuthCallback } from './pages/AuthCallback';
import { AdminDashboard } from './pages/AdminDashboard';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ProfilePage } from './pages/ProfilePage';
import WallPage from './pages/WallPage';
import NotificationsPage from './pages/NotificationsPage';
import { GroupsPage } from './pages/GroupsPage';
import { GroupDetailPage } from './pages/GroupDetailPage';
import { MobileToolbar } from './components/shared/MobileToolbar';
import './App.css';

// Analytics tracker component
/* function AnalyticsTracker() {
  const location = useLocation();
  const lastTrackedPathRef = React.useRef<string>('');

  useEffect(() => {
    // Evitar trackear la misma página múltiples veces
    if (lastTrackedPathRef.current !== location.pathname) {
      lastTrackedPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
}

} */

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Analytics />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/terminos" element={<TermsPage />} />
            <Route path="/privacidad" element={<PrivacyPage />} />

            {/* Protected routes */}
            {/* Temporalmente ocultas */}
            {/* <Route path="/wall" element={<WallPage />} /> */}
            {/* <Route path="/grupos" element={<GroupsPage />} /> */}
            {/* <Route path="/grupos/:groupId" element={<GroupDetailPage />} /> */}
            {/* <Route
              path="/notificaciones"
              element={
                <ProtectedRoute>
                  <NotificationsPage />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/perfil"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/perfil/:userId"
              element={<ProfilePage />}
            />

            {/* Admin routes */}
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute requireRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <MobileToolbar />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
